import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { MovimientoInventario } from '../types/movimiento.types';

interface MovimientoInventarioStore {
  movimientos: MovimientoInventario[];
  loading: boolean;
  filtroTipo: string;

  setMovimientos: (movimientos: MovimientoInventario[]) => void;
  setLoading: (loading: boolean) => void;
  setFiltroTipo: (tipo: string) => void;
}

export const useMovimientoInventarioStore = create<MovimientoInventarioStore>()(
  devtools(
    (set) => ({
      movimientos: [],
      loading: false,
      filtroTipo: '',

      setMovimientos: (movimientos) => set({ movimientos }),
      setLoading: (loading) => set({ loading }),
      setFiltroTipo: (filtroTipo) => set({ filtroTipo }),
    }),
    { name: 'MovimientoInventarioStore' }
  )
);
